module.exports = __webpack_public_path__ + "img/image-lectura.1d8aef87.png";